import React, { ReactElement, useState, useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import isFieldError from '../../../helpers/isFieldError';
import Tooltip from '../../../valoracion/components/Form/InputField/Tooltip/Tooltip';
import styles from './selectField.module.scss';

export type Variant = 'tiny' | 'default';
export interface SelectFieldProps {
  select: React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >;
  label?: string | ReactElement;
  error?: string | FieldError;
  children: React.ReactNode;
  placeholder?: string;
  strict?: boolean;
  tooltip?: string;
  variant?: Variant;
}

const stylePicker = (variant: Variant): string => {
  switch (variant) {
    case 'tiny':
      return styles.isTiny;
    case 'default':
      return '';
  }
};

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  error,
  select,
  children,
  placeholder,
  strict = false,
  tooltip,
  variant = 'default',
}) => {
  const [hasValue, setHasValue] = useState(
    strict
      ? select.defaultValue === 0 || !!select.defaultValue
      : !!select.defaultValue
  );

  const checkIfHasValue = useCallback((val) => setHasValue(val), [setHasValue]);

  const id = select.id || select.name;
  const errorMessage: string | JSX.Element = isFieldError(error)
    ? error.message || ''
    : error || '';
  const tooltipText = tooltip
    ? tooltip === 'error'
      ? errorMessage
      : tooltip
    : '';
  return (
    <div className={`${styles.row} ${tooltipText ? styles.hasTooltip : ''}`}>
      <label className={`${styles.label} ${stylePicker(variant)}`} htmlFor={id}>
        {label}
      </label>
      {tooltipText && <Tooltip text={tooltipText} />}
      <select
        onChange={(e) => {
          checkIfHasValue(e.target.value);
          select.onChange && select.onChange(e);
        }}
        data-testid={id}
        className={`${styles.selectDropDown} 
        ${hasValue || !placeholder ? styles.hasValue : ''} ${stylePicker(
          variant
        )}`}
        id={id}
        {...select}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {children}
      </select>
      {error && tooltip !== 'error' && (
        <p className={styles.errorText}>{errorMessage}</p>
      )}
    </div>
  );
};

export default SelectField;
